<template>
  <div class="auth-page">
    <div class="auth-page__logo text-center pt-8">
      <a :href="basePath">
        <icon-base icon="logo" alt="" />
      </a>
    </div>

    <div class="auth-page__content pl-4 pr-4">
      <slot />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AuthPageLayout',
  computed: {
    ...mapState('auth', ['loginInfo']),
    basePath() {
      return this.loginInfo?.base_domain || 'https://conveyour.com';
    },
  },
};
</script>

<style lang="less">
.auth-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-bottom: 24px;

  &__content {
    flex: 1;
  }
}
</style>
